module.exports = __webpack_public_path__ + "static/img/10.9bcd3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/10.jpg
// module id = VVZB
// module chunks = 1